import React from 'react'
import PropTypes from 'prop-types'
import { Pie} from '@ant-design/plots';

export default class OptimalPie extends React.Component {

  static propTypes = {
    optimalData: PropTypes.object
  }

  state = {
    pieData: {},
    isNarrow: false,
  }

  constructor (props) {
    super(props)
    const {optimalData} = this.props
    if (optimalData) {
      this.state = {
        pieData: optimalData,
        isNarrow: this.getIsNarrowViewport(),
      }
    }
  }

  componentDidMount() {
    this.mediaQueryList = this.createMediaQueryList();
    this.syncViewportMode();

    if (this.mediaQueryList) {
      if (this.mediaQueryList.addEventListener) {
        this.mediaQueryList.addEventListener('change', this.handleViewportChange);
      } else if (this.mediaQueryList.addListener) {
        this.mediaQueryList.addListener(this.handleViewportChange);
      }
    } else if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleViewportChange);
    }
  }

  componentWillUnmount() {
    if (this.mediaQueryList) {
      if (this.mediaQueryList.removeEventListener) {
        this.mediaQueryList.removeEventListener('change', this.handleViewportChange);
      } else if (this.mediaQueryList.removeListener) {
        this.mediaQueryList.removeListener(this.handleViewportChange);
      }
    } else if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleViewportChange);
    }
  }

  updatePieData = (data) => {
    this.setState({
      pieData: data,
    });
  };

  componentDidUpdate(prevProps) {
    const { optimalData } = this.props;
    if (optimalData && optimalData !== prevProps.optimalData && optimalData !== this.state.pieData) {
      this.setState({
        pieData: optimalData,
      });
    }
  }

  getIsNarrowViewport = () => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth <= 600;
  };

  createMediaQueryList = () => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return null;
    }
    return window.matchMedia('(max-width: 600px)');
  };

  syncViewportMode = () => {
    const nextIsNarrow = this.mediaQueryList ? this.mediaQueryList.matches : this.getIsNarrowViewport();
    if (nextIsNarrow !== this.state.isNarrow) {
      this.setState({
        isNarrow: nextIsNarrow,
      });
    }
  };

  handleViewportChange = () => {
    this.syncViewportMode();
  };

  renderBarChart = (data = []) => {
    return (
      <div className='optimal-allocation-bar-chart'>
        {data.map((item) => {
          const value = Math.max(0, Number(item.value) || 0);
          const label = item.displayLabel || item.assetLabel || item.shortLabel || item.type;
          const ratioLabel = `${value.toFixed(1)}%`;

          return (
            <div
              key={item.type}
              className='optimal-allocation-bar-row'
              title={item.fullName || label}
            >
              <div className='optimal-allocation-bar-header'>
                <span className='optimal-allocation-bar-label'>{label}</span>
                <span className='optimal-allocation-bar-value'>{ratioLabel}</span>
              </div>
              <div className='optimal-allocation-bar-track'>
                <div
                  className='optimal-allocation-bar-fill'
                  style={{
                    width: `${Math.min(value, 100)}%`,
                    backgroundColor: item.color || item.Color || '#4e79a7',
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { pieData, isNarrow } = this.state;
    const data = pieData?.data || [];

    if (isNarrow) {
      return this.renderBarChart(data);
    }
 
    return (
            <div className='optimal-pie-chart'>
              <Pie {...pieData} />
            </div>
    );
  }
}
